import { useEffect, useState } from 'react';
import { getZonedDate, DayjsWithTZ } from '@/utils/dayjs';

const TICK_INTERVAL_MS = 1000;

/**
 * 指定タイムゾーンで現在時刻を 1 秒ごとに更新するフック
 */
export const useZonedNow = (timeZone?: string): DayjsWithTZ => {
    const [now, setNow] = useState<DayjsWithTZ>(() => getZonedDate(timeZone));

    useEffect(() => {
        const update = () => setNow(getZonedDate(timeZone));
        update();
        const timerId = window.setInterval(update, TICK_INTERVAL_MS);
        return () => window.clearInterval(timerId);
    }, [timeZone]);

    return now;
};
